import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Number Projections",
description: "Learn how to display numeric properties in Freon using the slider control and how to configure default number projections in the global editor settings.",
tags: [ "number projections", "slider", "numeric properties", "editor controls", "global projections", "projectional editor", "Freon", "DSL development"] ,
modifiedTime: "2025-11-07T18:12:52.262Z",
publishedTime: "2025-11-07T17:20:18.610Z"
    }
  };
};